'use client';
import React from 'react';
import {
  StyledDigitContainer,
  StyledDigitInner,
  StyledNumber,
  StyledPriceSpinnerWrapper,
  StyledSpinnerContainer
} from './styled';

export type PriceSpinnerProps = { value: string[] };

export const PriceSpinner = ({ value }: PriceSpinnerProps) => {
  const shouldShowComma = value.every((item) => Boolean(item));
  return (
    <StyledPriceSpinnerWrapper>
      AED
      <StyledSpinnerContainer>
        {value.map((digit, index) => {
          if (digit === ',') {
            if (shouldShowComma) {
              // eslint-disable-next-line
              return <div key={index}>,</div>;
            } else {
              // eslint-disable-next-line
              return <div key={index} style={{ display: 'none' }} />;
            }
          } else {
            return (
              // eslint-disable-next-line
              <StyledDigitContainer key={index} $digit={digit}>
                <StyledDigitInner $digit={digit}>
                  {Array.from({ length: 10 }, (_, i) => (
                    <StyledNumber key={i}>{i}</StyledNumber>
                  ))}
                </StyledDigitInner>
              </StyledDigitContainer>
            );
          }
        })}
      </StyledSpinnerContainer>
    </StyledPriceSpinnerWrapper>
  );
};
